import { render, staticRenderFns } from "./VozEcosystemAndCompanyBrand.vue?vue&type=template&id=cc632952"
import script from "./VozEcosystemAndCompanyBrand.vue?vue&type=script&lang=ts"
export * from "./VozEcosystemAndCompanyBrand.vue?vue&type=script&lang=ts"
import style0 from "./VozEcosystemAndCompanyBrand.vue?vue&type=style&index=0&id=cc632952&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports